module.exports = __webpack_public_path__ + "img/petri-dish-emoji.7771c9a5.png";